import React from 'react'

import { AppSvg, FormattedCurrency, FormattedHTMLMessage, newIcons } from '@web/walter-ui-kit'
import cn from 'classnames'
import { getAmountClassName, getTxSvgName } from '../utils'
import s from './s.module.css'
import { lang } from './lang'
import { formatDate as formatDateUtil } from '~utils/date'
import { Transaction } from '~pages/CardsPage/Cards/Transactions/types'

const getSvgAlertName = (type: Transaction['transaction_type'], status: Transaction['status']) => {
    if (status === 'Authorized') {
        return newIcons.ic16Time
    }
    if (status === 'Declined' || status === 'Reversed') {
        return newIcons.ic16ErrorCircle
    }

    return undefined
}

const getSvgAlertClassName = (type: Transaction['transaction_type'], status: Transaction['status']) => {
    if (status === 'Authorized') {
        return s.pendingAlertIcon
    }
    if (status === 'Declined' || status === 'Reversed') {
        return s.errorAlertIcon
    }

    return undefined
}

const showPlus = (type: Transaction['transaction_type']) => {
    return type === 'deposit'
}

const getDefaultText = (type: Transaction['transaction_type']) => {
    if (type === 'deposit') {
        return <FormattedHTMLMessage {...lang.deposit} />
    }

    if (type === 'payment') {
        return <FormattedHTMLMessage {...lang.payment} />
    }

    return null
}

interface Props {
    data: Transaction
    onClick: () => void
}

function TransactionRow({ data, onClick }: Props) {
    const svgName = getTxSvgName(data.transaction_type)
    const svgAlertName = getSvgAlertName(data.transaction_type, data.status)
    const amountClassName = getAmountClassName(data.transaction_type, data.status)
    const alertClassName = getSvgAlertClassName(data.transaction_type, data.status)

    return (
        <div className={s.wrap} onClick={onClick}>
            <div className={s.left}>
                <div className={s.icon}>{svgName && <AppSvg size={24} svgName={svgName} path="new-icons" />}</div>
                <div className={s.leftContent}>
                    <div className={s.title}>{data.merchant_data?.name || getDefaultText(data?.transaction_type)}</div>
                    <div className={s.time}>
                        {formatDateUtil({ date: data.timeForRow || data.created_at, formatString: 'HH:mm' })}
                    </div>
                </div>
            </div>
            <div className={s.right}>
                <div className={cn(s.amount, amountClassName)}>
                    {showPlus(data.transaction_type) ? '+' : undefined}
                    <FormattedCurrency
                        maxPrecision={2}
                        minimumFractionDigits={2}
                        full
                        value={data.amount}
                        currency={data.currency || ''}
                        dataPointer="amount"
                    />
                </div>
                {svgAlertName && (
                    <div className={cn(s.alertIcon, alertClassName)}>
                        {svgName && <AppSvg size={16} svgName={svgAlertName} path="new-icons" />}
                    </div>
                )}
            </div>
        </div>
    )
}

export default TransactionRow
